import Swiper from 'swiper';
// import 'remodal';

// スクロール
var Ease = {
	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
};
var duration = 500;
window.addEventListener('DOMContentLoaded', () => {
	var smoothScrollTriggers = document.querySelectorAll('.anchor');
	smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
		smoothScrollTrigger.addEventListener('click', function (e) {
			var href = smoothScrollTrigger.getAttribute('href');
			var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
			var targetElement = document.getElementById(href.replace('#', ''));
			if (targetElement) {
				e.preventDefault();
				e.stopPropagation();
				var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - 20;
				var startTime = performance.now();
				var loop = function (nowTime) {
					var time = nowTime - startTime;
					var normalizedTime = time / duration;
					if (normalizedTime < 1) {
						window.scrollTo(0, currentPostion + (targetPosition - currentPostion) * Ease.easeInOut(normalizedTime));
						requestAnimationFrame(loop);
					} else {
						window.scrollTo(0, targetPosition);
					}
				};
				requestAnimationFrame(loop);
			}
		});
	});

	// スライダー
	let slide = document.querySelectorAll('.pickup .slide');
	for (let i = 0; i < slide.length; i++) {
		let mySwiper = null;

		const mediaQuery = window.matchMedia('(max-width: 559px)');

		const checkBreakpoint = (e) => {
			if (e.matches) {
				initSwiper();
			} else if (mySwiper) {
				mySwiper.destroy(false, true);
			}
		};

		const initSwiper = () => {
			const swiperVisual = document.querySelectorAll('.pickup .visual')[i];
			mySwiper = new Swiper(swiperVisual, {
				loop: true,
				slidesPerView: 2.2,
				spaceBetween: 12,
				speed: 400,
				preventClicks: false,
				preventClicksPropagation: false,
				// navigation: {
				// 	nextEl: document.querySelectorAll('.pickup .swiper-button-next')[i],
				// 	prevEl: document.querySelectorAll('.pickup .swiper-button-prev')[i],
				// },
			});
		};
		// mediaQuery.addListener(checkBreakpoint);
		mediaQuery.addEventListener('change', checkBreakpoint);
		checkBreakpoint(mediaQuery);
	}

	// KV動画の出し分け（PC / SP）
	const kvVideo = document.getElementById('kvVideo');
	if (kvVideo) {
		const kvMql = window.matchMedia('(max-width: 559px)');
		const setKvSrc = () => {
			const src = kvMql.matches ? kvVideo.dataset.srcSp : kvVideo.dataset.srcPc;
			if (kvVideo.currentSrc && kvVideo.currentSrc.indexOf(src) !== -1) return;
			kvVideo.src = src;
			kvVideo.load();
			kvVideo.play().catch(() => {});
		};
		setKvSrc();
		kvMql.addEventListener('change', setKvSrc);
	}

	// KVミュートボタン
	const kvMuteBtn = document.getElementById('kvMuteBtn');
	if (kvMuteBtn && kvVideo) {
		kvMuteBtn.addEventListener('click', () => {
			kvVideo.muted = !kvVideo.muted;
			const icon = kvMuteBtn.querySelector('i');
			icon.className = kvVideo.muted ? 'fa-solid fa-volume-xmark' : 'fa-solid fa-volume-high';
		});
	}

	// PICK UP動画: モーダル再生
	const videoModal = document.getElementById('videoModal');
	const videoModalVideo = document.getElementById('videoModalVideo');
	const videoModalClose = document.getElementById('videoModalClose');
	const videoModalOverlay = document.getElementById('videoModalOverlay');

	let scrollY = 0;
	const lockScroll = () => {
		scrollY = window.scrollY;
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollY}px`;
		document.body.style.width = '100%';
	};
	const unlockScroll = () => {
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.width = '';
		window.scrollTo(0, scrollY);
	};

	const openVideoModal = (src, poster) => {
		videoModalVideo.poster = poster;
		videoModalVideo.src = src;
		videoModal.classList.add('is-open');
		videoModal.setAttribute('aria-hidden', 'false');
		lockScroll();
		videoModalVideo.play().catch(() => {});
		if (kvVideo && !kvVideo.muted) {
			kvVideo.muted = true;
			if (kvMuteBtn) kvMuteBtn.querySelector('i').className = 'fa-solid fa-volume-xmark';
		}
	};

	const closeVideoModal = () => {
		videoModalVideo.pause();
		videoModalVideo.src = '';
		videoModal.classList.remove('is-open');
		videoModal.setAttribute('aria-hidden', 'true');
		unlockScroll();
	};

	document.querySelectorAll('.pickup__style--thumb-wrap').forEach((wrap) => {
		wrap.addEventListener('click', () => {
			const thumb = wrap.querySelector('.pickup__style--thumb');
			openVideoModal(thumb.dataset.videoSrc, thumb.src);
		});
	});

	if (videoModalClose) videoModalClose.addEventListener('click', closeVideoModal);
	if (videoModalOverlay) videoModalOverlay.addEventListener('click', closeVideoModal);
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') closeVideoModal();
	});

	// スクロールアニメーション;
	funcAnim();
});

// window.addEventListener('load', function () {

// });

const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');
	const observeAction = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// console.log('きた');
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		// root: root,
		rootMargin: '0px 0px -10% 0px',
	};

	const obsever = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		obsever.observe(target);
	});
};
